import { useEffect, useState } from 'react';
import paymentAcceptance from 'repos/tekoApis/paymentAcceptance';
import {
  IMerchant,
  IMerchantCreate,
  IParamSearchMerchant,
  IMerchantStatus,
  IMerchantBFF,
  IShopOfMerchant,
} from 'interfaces/merchant';
import { merchantService } from 'services';
import { defaultPage, defaultPageSize } from 'constants/pagination';
import { merchantConstants } from 'constants/index';

const { LOAD_MORE_MERCHANT_MAX } = merchantConstants;

export const useCreateMerchant = () => {
  const [merchantCreated, setMerchantCreated] = useState<IMerchant | null>(
    null
  );
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState<IMerchantCreate>();
  const createMerchant = async () => {
    if (params) {
      try {
        setLoading(true);
        const result = await paymentAcceptance.createMerchant(params);
        if (result) {
          const { data } = result;
          if (data) {
            setMerchantCreated(data);
          }
        } else {
          setMerchantCreated(null);
        }
        return result;
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (params) {
      createMerchant().then();
    }
  }, [params]);
  return { merchantCreated, setParams, loading };
};

const useMerchant = () => {
  const initParams = {
    merchantStatus: IMerchantStatus.APPROACHING,
    withLastestTicket: true,
    pageSize: defaultPageSize,
    page: defaultPage,
  };

  const [params, setParams] = useState<IParamSearchMerchant>(initParams);
  const [merchants, setMerchants] = useState<IMerchantBFF[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isMerchantExist, setIsMerchantExist] = useState<boolean>(false);

  const getMerchants = async () => {
    try {
      if (params.page === defaultPage) setLoading(true);
      const res = await merchantService.getMerchants(params);
      if (res.data) {
        setIsMerchantExist(false);
        setHasMore(res.data.merchant.length === defaultPageSize);
        if (params.page === defaultPage) setMerchants(res.data.merchant);
        else {
          const moreMerchant = [...merchants, ...res.data.merchant];
          setMerchants(moreMerchant);
          if (
            params.merchantStatus !== IMerchantStatus.APPROACHING &&
            moreMerchant.length >= LOAD_MORE_MERCHANT_MAX
          ) {
            setHasMore(false);
          }
        }
      } else {
        setMerchants([]);
        setIsMerchantExist(true);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (params.searchText) getMerchants();
  }, [params]);

  return {
    merchants,
    setParams,
    params,
    hasMore,
    loading,
    getMerchants,
    initParams,
    isMerchantExist,
    setIsMerchantExist,
  };
};
const useMerchantDetail = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [listShop, setListShop] = useState<IShopOfMerchant[]>([]);
  const [page, setPage] = useState<number>(defaultPage);
  const [hasMore, setHasMore] = useState(true);

  //get list shop of merchant
  const getListShopOfMerchant = async (
    id: number | undefined,
    p: number
  ): Promise<IShopOfMerchant[] | undefined> => {
    if (id) {
      try {
        const params = {
          page: p,
          pageSize: defaultPageSize,
        };

        if (p === defaultPage) setLoading(true);
        const result = await merchantService.getListShopOfMerchant(id, params);
        if (result && result.hasOwnProperty('data')) {
          setHasMore(result.data.shops.length === defaultPageSize);
          if (p === defaultPage) setListShop(result.data.shops);
          else setListShop([...listShop, ...result.data.shops]);
          setPage(p);
          return result.data.shops;
        }
      } finally {
        setLoading(false);
      }
    }
    return undefined;
  };

  return {
    loading,
    page,
    getListShopOfMerchant,
    listShop,
    hasMore,
  };
};

export default {
  useCreateMerchant,
  useMerchant,
  useMerchantDetail,
};
